import type Phaser from "phaser";
import { REGISTRY_KEYS, type AppMode } from "../app/GameApp";

export function mountAdminButton(game: Phaser.Game): void {
  if (document.getElementById("open-admin-btn")) return;
  const btn = document.createElement("button");
  btn.id = "open-admin-btn";
  btn.className = "admin-launch";
  btn.textContent = "⚙ Управление игрой";
  btn.addEventListener("click", () => { window.location.href = "/admin"; });
  document.body.appendChild(btn);

  const sync = (mode: AppMode) => { btn.style.display = mode === "map" ? "inline-flex" : "none"; };
  sync((game.registry.get(REGISTRY_KEYS.currentMode) as AppMode) ?? "boot");
  game.registry.events.on(`changedata-${REGISTRY_KEYS.currentMode}`, (_parent: unknown, value: AppMode) => sync(value));
}
